import { render, staticRenderFns } from "./company.vue?vue&type=template&id=6fe3785f&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=6fe3785f&scoped=true&lang=scss"
import style1 from "./company.vue?vue&type=style&index=1&id=6fe3785f&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe3785f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe3785f')) {
      api.createRecord('6fe3785f', component.options)
    } else {
      api.reload('6fe3785f', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=6fe3785f&scoped=true", function () {
      api.rerender('6fe3785f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/configure/company.vue"
export default component.exports